import React from 'react';
import BlotterFiltersModal from './BlotterFiltersModal';
import { useColumnDefinitions } from '../columns/ColumnPortfolio';
import { useBlotterConfigurationSelector } from '../store/configuration/selectors';
import { renderFilterIndicator } from 'appToolbar/ActiveFiltersIndicator';
import { RenderFilterOptions } from 'widgets/WidgetRegistry';
import { isColumnFilter } from 'widgets/store/grid/filters/FilterState';

export function renderBlotterFiltersIndicator(
    widgetId: string,
    options?: RenderFilterOptions
) {
    return <BlotterFiltersIndicator blotterId={widgetId} options={options} />;
}

export function BlotterFiltersIndicator(props: {
    blotterId: string;
    options?: RenderFilterOptions;
}) {
    const { blotterId, options } = props;

    const { filters } = useBlotterConfigurationSelector(blotterId);
    const columnDefinitions = useColumnDefinitions();

    if (options?.column) {
        const filter = filters.find(
            (f) => isColumnFilter(f) && f.column === options.column
        );
        if (!filter) {
            return <></>;
        }
    }

    return (
        <BlotterFiltersModal
            key="filters"
            columnDefinitions={columnDefinitions}
            blotterId={blotterId}
            trigger={options?.element ?? renderFilterIndicator(filters.length)}
        />
    );
}
